(() => {
  function init(root) {
    if (root.dataset.roleReady) return;
    root.dataset.roleReady = 'true';
    // A same-page anchor doesn't reload the document, so close the theme's
    // drawer through its own toggle (including focus trap and scroll lock).
    document.addEventListener('click', event => {
      const link = event.target.closest('header-drawer a[href], header-menu a[href]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname) return;
      const menu = link.closest('header-drawer, header-menu');
      const details = menu.querySelector('details');
      if (details && details.open) details.querySelector('summary').click();
    });
  }
  document.querySelectorAll('[data-role-hub]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-role-hub]').forEach(init);
  });
})();

